import { render } from "./HomeBlock.vue?vue&type=template&id=d4be6892"
import script from "./HomeBlock.vue?vue&type=script&lang=js"
export * from "./HomeBlock.vue?vue&type=script&lang=js"

import "./HomeBlock.vue?vue&type=style&index=0&id=d4be6892&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__